var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockUnlockLine = function SvgLockUnlockLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 10.198h11.7a.9.9 0 0 1 .9.9v9a.9.9 0 0 1-.9.9H5.3a.9.9 0 0 1-.9-.9v-9a.9.9 0 0 1 .9-.9h.9v-.9A6.3 6.3 0 0 1 18.136 6.48l-1.61.805A4.5 4.5 0 0 0 8 9.298zm-1.8 1.8v7.2h12.6v-7.2zm4.5 2.7h3.6v1.8h-3.6z"
  })));
};
export default SvgLockUnlockLine;